/**
 * Converts an array of JSON objects to an array of objects with string values.
 * Any non-string, non-null values are converted to a JSON string.
 * Any null or empty string values are converted to "__".
 * @param jsonData Array of JSON objects.
 * @returns Array of objects with string values.
 */
export const formateJsonIntoTableData = (
  jsonData: Record<PropertyKey, unknown>[],
): { formattedJsonData: Record<PropertyKey, string>[]; tableColumnKeys: (string | number)[] } => {
  const formattedJsonData = []
  const uniqueJsonKeys = new Set<string | number>()

  for (const item of jsonData) {
    // this line to avoid modifying the original obj
    const itemData = { ...item }

    Object.entries(itemData).forEach(([key, value]) => {
      uniqueJsonKeys.add(key)

      if (typeof value === "object" && value != null) {
        itemData[key] = JSON.stringify(value)
      }

      if (value == null || (typeof value === "string" && value.trim() === "")) itemData[key] = "__"
    })

    formattedJsonData.push(itemData as Record<PropertyKey, string>)
  }

  return { formattedJsonData, tableColumnKeys: Array.from(uniqueJsonKeys) }
}
